"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { createContext, type ReactNode, use, useCallback, useEffect, useMemo, useState } from "react";
import { useIsSharedView } from "@/contexts/SharedViewContext";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { CLIENT_INVALIDATION_CONNECTION_STATUS, CLIENT_INVALIDATION_SSE_EVENT, type ClientInvalidationConnectionStatus } from "@/lib/client-invalidation/catalog";
import { invalidateOnReconnect } from "@/lib/client-invalidation/invalidate-on-reconnect";
import { invalidateQueriesForEventPayload } from "@/lib/client-invalidation/invalidate-queries-for-event-payload";
import { clientInvalidationSseUrl } from "@/lib/client-invalidation/sse-url";
import { useAuthStore } from "@/lib/stores/authStore";
import { getQueryClient } from "@/queries/config/query-client";
type ClientInvalidationContextValue = {
  status: ClientInvalidationConnectionStatus;
};
const ClientInvalidationContext = createContext<ClientInvalidationContextValue | null>(null);
export function ClientInvalidationProvider(t0) {
  const $ = _c(23);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  const user = useAuthStore(_temp);
  const isAuthenticated = useAuthStore(_temp2);
  const isSharedView = useIsSharedView();
  const {
    workspaceId
  } = useCurrentWorkspace();
  const [status, setStatus] = useState(CLIENT_INVALIDATION_CONNECTION_STATUS.closed);
  user?.id;
  user?.organizationId;
  const t2 = user?.organizationId;
  const t3 = user?.id;
  const t4 = workspaceId || undefined;
  let t5;
  if ($[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = {
      organizationId: t2,
      userId: t3,
      workspaceId: t4
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const reconnectSession = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event => {
      const messageEvent = event as MessageEvent<string>;
      if (typeof messageEvent.data !== "string") {
        return;
      }
      invalidateQueriesForEventPayload({
        payload: messageEvent.data,
        queryClient
      });
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleInvalidation = t6;
  let t7;
  if ($[6] !== isAuthenticated || $[7] !== isSharedView || $[8] !== reconnectSession || $[9] !== user?.id || $[10] !== workspaceId) {
    t7 = function subscribeToClientInvalidations() {
      if (!isAuthenticated || !user?.id || isSharedView) {
        setStatus(CLIENT_INVALIDATION_CONNECTION_STATUS.closed);
        return;
      }
      const eventSource = new EventSource(clientInvalidationSseUrl(workspaceId || undefined));
      let hasOpened = false;
      const handleOpen = () => {
        setStatus(CLIENT_INVALIDATION_CONNECTION_STATUS.open);
        if (!hasOpened) {
          hasOpened = true;
          return;
        }
        invalidateOnReconnect({
          queryClient,
          ...reconnectSession
        });
      };
      const handleError = () => {
        setStatus(CLIENT_INVALIDATION_CONNECTION_STATUS.closed);
      };
      eventSource.addEventListener("open", handleOpen);
      eventSource.addEventListener("error", handleError);
      eventSource.addEventListener(CLIENT_INVALIDATION_SSE_EVENT.invalidation, handleInvalidation);
      return () => {
        eventSource.removeEventListener("open", handleOpen);
        eventSource.removeEventListener("error", handleError);
        eventSource.removeEventListener(CLIENT_INVALIDATION_SSE_EVENT.invalidation, handleInvalidation);
        eventSource.close();
        setStatus(CLIENT_INVALIDATION_CONNECTION_STATUS.closed);
      };
    };
    $[6] = isAuthenticated;
    $[7] = isSharedView;
    $[8] = reconnectSession;
    $[9] = user?.id;
    $[10] = workspaceId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = user?.id;
  let t9;
  if ($[12] !== isAuthenticated || $[13] !== isSharedView || $[14] !== reconnectSession || $[15] !== t8 || $[16] !== workspaceId) {
    t9 = [handleInvalidation, isAuthenticated, isSharedView, queryClient, reconnectSession, t8, workspaceId];
    $[12] = isAuthenticated;
    $[13] = isSharedView;
    $[14] = reconnectSession;
    $[15] = t8;
    $[16] = workspaceId;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  useEffect(t7, t9);
  let t10;
  if ($[18] !== status) {
    t10 = {
      status
    };
    $[18] = status;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const value = t10;
  let t11;
  if ($[20] !== children || $[21] !== value) {
    t11 = <ClientInvalidationContext value={value}>{children}</ClientInvalidationContext>;
    $[20] = children;
    $[21] = value;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
function _temp2(state_0) {
  return state_0.isAuthenticated;
}
function _temp(state) {
  return state.user;
}
export function useClientInvalidationConnection(): ClientInvalidationContextValue {
  const context = use(ClientInvalidationContext);
  if (!context) {
    return {
      status: CLIENT_INVALIDATION_CONNECTION_STATUS.closed
    };
  }
  return context;
}